import RdcTracking from "@rdc-npm/rdc-tracking";
import { TRACKING_EVENTS } from "./trackingConstants";

const trackOmnitureClicks = (linkData) => {
  RdcTracking.trackEvent(TRACKING_EVENTS.CLICK, { linkName: linkData });
};
const trackOmnitureLead = (leadPlacement, modal_name = "") => {
  RdcTracking.trackEvent(TRACKING_EVENTS.FAR_LEAD, {
    leadPlacement: leadPlacement,
    ...(modal_name && { modalName: modal_name }),
  });
};
const trackOmnitureBannerLead = (leadPlacement) => {
  RdcTracking.trackEvent(TRACKING_EVENTS.BANNER_FORM_LEAD, {
    leadPlacement: leadPlacement,
    modalName: "nonNARSubmitToViewProfile",
  });
};
const trackOmnitureSearch = (
  linkName = "",
  searchBox = "",
  searchCategory = "",
  searchQuery = "",
) => {
  RdcTracking.trackEvent(TRACKING_EVENTS.SEARCH, {
    linkName: linkName,
    searchBox: searchBox,
    searchCategory: searchCategory,
    searchQuery: searchQuery,
  });
};
const trackOmnitureShare = (type, data) => {
  RdcTracking.trackEvent(type, { socialShare: data });
};

const trackOmnitureModalImpression = (properties) => {
  RdcTracking.trackEvent(TRACKING_EVENTS.MODAL_IMPRESSION, properties);
};

const trackOmnitureModuleImpression = (properties) => {
  RdcTracking.trackEvent(TRACKING_EVENTS.MODULE_IMPRESSION, properties);
};

const trackOmniturePageLoad = (pageName, properties) => {
  RdcTracking.trackPage(pageName, properties);
};
const trackOmnitureRefinedSearch = (searchFilterOne) => {
  RdcTracking.trackEvent(TRACKING_EVENTS.REFINED_SEARCH, { searchFilterOne: searchFilterOne });
};

module.exports = {
  trackOmnitureClicks,
  trackOmnitureModalImpression,
  trackOmniturePageLoad,
  trackOmnitureShare,
  trackOmnitureLead,
  trackOmnitureSearch,
  trackOmnitureRefinedSearch,
  trackOmnitureBannerLead,
  trackOmnitureModuleImpression,
};
